import ENV from "app/utils/ENV";
import React from "react";
import alertModule from "app/utils/alertModule";
import haptics from "app/utils/haptics";

let alertActions = {
  async confirm({
    text = "",
    options = [],
    optionStyles = [],
    title = "",
    subtitle = "",
    allowCancel = true,
  }) {
    // haptics.warn();
    if (typeof arguments[0] == "string") title = arguments[0];
    let buttonOptions = options;
    if (!options.length && !text?.length) text = "Confirm";

    let buttons = [];
    return new Promise(async (resolve, reject) => {
      if (!!text?.length)
        buttons.push({
          label: text,
          text: text,
          onClick: () => resolve(1),
          onPress: () => resolve(1),
          style: text.toLowerCase().includes("delete")
            ? "destructive"
            : "default",
        });
      if (!!buttonOptions?.length) {
        // if(!optionStyles?.length){
        //   optionStyles
        // }
        buttonOptions.forEach((opt, i) => {
          if (!!opt?.length) {
            let index = i + 1;
            if (!!text?.length) index += 1;
            buttons.push({
              label: opt,
              text: opt,
              onClick: () => resolve(index),
              onPress: () => resolve(index),
              style:
                optionStyles[i] ||
                (opt.toLowerCase().includes("delete")
                  ? "destructive"
                  : "default"),
            });
          }
        });
      }
      if (allowCancel) {
        buttons.push({
          label: `Cancel`,
          text: `Cancel`,
          onClick: () => resolve(0),
          onPress: () => resolve(0),
          style: "cancel",
        });
      }

      if (title != null) title = !title?.length ? "Please select" : title;
      subtitle = !subtitle?.length ? "" : subtitle;

      return await alertModule.confirm({ title, subtitle, buttons });
    });
  },
};

export default alertActions;
